<template>
   <div data-testid="materiality-approvals-list" class="all-height all-width">
    <div>
      <div class="d-flex mb-4">
        <CommonCountCard
          :count="formattedData.length"
          page-name="access_management"
          label-key="commentary_pending_requests_label"
          fallback-label="Pending Requests"
          :loading="loading"
          data-testid="materiality-approvals-list__count-card"
        />
        <v-spacer></v-spacer>
      </div>
       
    <div data-testid="materiality-approvals-list__table" v-if="!viewGLLevelshow">
      <lb-datatablenew 
        v-if="formattedData.length > 0"
        :headers="headers" 
        :items="formattedData"
        :enableslot="['created_at', 'submittername', 'approvedby', 'approvedon', 'action', 'stage']"
        :loading="loading" 
        :sortByDate="true"
        data-testid="materiality-approvals-list__datatable"
      >
        <template v-slot:created_at="{ item }">
          <div data-testid="materiality-approvals-list__created-at">{{ $nova.formatDateTime(item.created_at) }}</div>
        </template>
        <template v-slot:submittername="{ item }">
        <div v-if="item.submitter_detail">
          <span data-testid="materiality-approvals-list__submitter-name">{{ item.submitter_detail?.name }}</span>
          <br />
          <span data-testid="materiality-approvals-list__submitter-email"><v-chip class="defaultChip">{{ item.submitter_detail?.email }}</v-chip></span>
          </div>
        </template>
        <template v-slot:approvedon="{ item }">
          <span data-testid="materiality-approvals-list__approved-on">{{ $nova.formatDateTime(item.approvedate) || "" }}</span>
        </template>
        <template v-slot:stage="{ item }">
          <StatusIndicator
            :variant="getStageVariant(item.stage)"
            :custom-label="getStageLabel(item.stage)"
            size="sm"
            :data-testid="`materiality-approvals-list__stage-${item.stage.toLowerCase()}`"
          />
        </template>
        <template v-slot:action="{ item }">
          <v-tooltip bottom content-class="tooltip-bottom">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                icon 
                v-bind="attrs" 
                v-on="on" 
                @click="getDetails(item)"
                data-testid="materiality-approvals-list__view-btn"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
        </template>
      </lb-datatablenew>
      <div v-else class="title grey--text pa-5 text-center" data-testid="materiality-approvals-list__no-data">
      No Data Found
    </div>
    </div>
    <div v-else>
        
        {{ viewGLLevelshow }}
    </div>
    
    </div>
    </div>
</template>
<script>
import StatusIndicator from '@/components/StatusIndicator.vue';
import CommonCountCard from '@/components/CommonCountCard.vue';
import { STATUS_VARIANTS } from '@/components/utils/status-constants';

export default {
  name: "MaterialApprovalsList",
  components: {
    StatusIndicator,
    CommonCountCard
  },
  data() {
    return {
      // Status count for different approval stages
      dataStatusCount: {
        open: 0,
        approved: 0,
        rejected: 0,
        retry: 0
      },
      // Color mapping for different request types
      colors: {},
      // Formatted data for the table
      formattedData: [],
      headers: [
        {
          value: "indexno",
          text: "S.No",
          sortable: false,
          filterable: false,
        },
        {
          value: "typetext",
          text: "Request type",
          sortable: false,
          filterable: true,
          datatype: "string",
          lock: true,
          visible: false,
         
        },
        {
          type: "string",
          value: "submittername",
          text: "Submitted by",
          sortable: false,
          filterable: true,
         
        },
        {
          type: "date",
          value: "created_at",
          text: "Submitted on",
          sortable: true,
          defaultsort: 'desc'
        },
        {
          type: "string",
          value: "stage",
          text: "Status",
          sortable: true,
          filterable: true,
         
        },
        {
          value: "action",
          text: "Action",
          sortable: false,
          alignment: 'px-1'
        }
      ],
      viewGLLevelshow:false,
    };
  },
  props: {
    approvalsData: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // Watch for changes in approvalsData and reformat
    approvalsData: {
      handler(newData) {
        this.formatData(newData);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    /**
     * Format the raw approvals data for table display
     * Maps stage values to readable names and counts statuses
     * @param {Array} data - Raw approvals data from API
     */
    formatData(data) {
      // Reset status counts before processing
      this.resetStatusCount();
      
      let ArrayTemp = [];
      data.forEach((i, k) => {
        i.__key = k;
        i.indexno = k + 1;
        let stageName = "";
        
        // Map stage values to readable names and update counts
        if (i.stage === 0 || i.stage === "Open") {
          stageName = "Open";
          this.dataStatusCount.open++;
        } else if (i.stage === 1 || i.stage === "Approved") {
          stageName = "Approved";
          this.dataStatusCount.approved++;
        } else if (i.stage === -1 || i.stage === "Rejected") {
          stageName = "Rejected";
          this.dataStatusCount.rejected++;
        } else if (i.stage === 2 || i.stage === "inProgress") {
          stageName = "inProgress";
          this.dataStatusCount.open++;
        } else if (i.stage === 3 || i.stage === "Retry") {
          stageName = "Retry";
          this.dataStatusCount.retry++;
        }
        
        i.stage = stageName;
        i.submittername = i.submitter_detail?.displayname || "";
        i.approvedby = i.approver_detail?.displayname || "";
        i.approvedon = i.approvedate || "";
        i.stageName = stageName;
        ArrayTemp.push(i);
      });
      
      this.setColors();
      this.formattedData = ArrayTemp;
    },
    
    /**
     * Reset all status counts to zero
     */
    resetStatusCount() {
      this.dataStatusCount = {
        open: 0,
        approved: 0,
        rejected: 0,
        retry: 0
      };
    },
    
    /**
     * Set color mapping for different request types
     */
    setColors() {
      this.colors = {
        accesschange: "accent",
        bulkaccesschange: "accent",
        fileaccesschange: "accent",
        materialityrulevel: "caccent",
        bulkmaterialityrulevel: "caccent",
        filematerialityrulevel: "caccent",
        materialitygllevel: "caccent",
        bulkmaterialitygllevel: "caccent",
        filematerialitygllevel: "caccent",
        materialitysllevel: "caccent",
        bulkmaterialitysllevel: "caccent",
        filematerialitysllevel: "caccent"
      };
    },
    
    /**
     * Handle view details action for an item
     * @param {Object} item - The approval item to view details for
     */
    getDetails(item) {
    this.viewGLLevelshow = true;
      this.$emit('view-details', item);
    },
    
    /**
     * Get the StatusIndicator variant based on stage value
     * @param {String} stage - The stage value
     * @returns {String} The corresponding STATUS_VARIANTS value
     */
    getStageVariant(stage) {
      const stageVariantMap = {
        'Open': STATUS_VARIANTS.OPEN,
        'Approved': STATUS_VARIANTS.APPROVED,
        'Rejected': STATUS_VARIANTS.REJECTED,
        'inProgress': STATUS_VARIANTS.IN_PROGRESS,
        'Retry': STATUS_VARIANTS.FAILED
      };
      return stageVariantMap[stage] || STATUS_VARIANTS.UNKNOWN;
    },
    
    /**
     * Get the display label for a stage
     * @param {String} stage - The stage value
     * @returns {String} The display label
     */
    getStageLabel(stage) {
      const stageLabelMap = {
        'Open': 'Open',
        'Approved': this.$nova.labelsName('access_management', 'commentary_approved_label', 'Approved'),
        'Rejected': this.$nova.labelsName('access_management', 'commentary_rejected_label', 'Rejected'),
        'inProgress': 'In Progress',
        'Retry': 'Failed'
      };
      return stageLabelMap[stage] || 'Unknown';
    }
  },
  
  /**
   * Cleanup on component destroy to prevent stale state
   */
  beforeDestroy() {
    this.formattedData = [];
    this.resetStatusCount();
    this.colors = {};
  }
};
</script>